export const FEATURE_FLAGS = {
  VDA_ACTIONS: "featureFlagVdaActions",
  QUEUE_MANAGER: "featureFlagQueueManager",
  LIVE_MISSIONS: "featureFlagLiveMissions",
  // RBAC plan §6.1 `ADMIN_CONSOLE_ENABLED`: shows/hides the Admin Console.
  ADMIN_CONSOLE_ENABLED: "featureFlagAdminConsoleEnabled",
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;
